var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { LoginAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var View = function (_a) {
    var props = __rest(_a, []);
    return (_jsx(LoginAFY, { title: props.title, subTitle: props.subTitle, emailText: props.emailText, logo: props.logo, emailPlaceHolder: props.emailPlaceHolder, emailRequired: props.emailRequired, emailError: props.emailError, emailHelperText: props.emailHelperText, codeText: props.codeText, codeRequired: props.codeRequired, codeHelperText: props.codeHelperText, labelButtonLogin: props.buttonText, btnColor: "#fffff", userForm: "ConfirmEmail", onSignIn: props.onSaveData }));
};
